import type { Ref } from 'vue';
import { watch } from 'vue';
import type { HekateDisplayForm, HekateDisplayField } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class CreatorProgramProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public override realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    if (!formDefinition.value) {
      return;
    }
    super.realtimeBranchModifications({ formDefinition });

    const studyEngineeringVal = ExternalUtil.findDisplayFieldValOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.studyEngineering,
    });

    const hideAll: HekateDisplayField[] = [
      ExternalUtil.findDisplayFieldOrThrow({
        formDefinition,
        fieldName: FieldHtmlNameUtil.highLevelEdu,
      }),
      ExternalUtil.findDisplayFieldOrThrow({
        formDefinition,
        fieldName: FieldHtmlNameUtil.majorInSchool,
      }),
    ];
    hideAll.forEach((field) => {
      field.componentName = 'hidden-field';
      field.isRequired = false;
    });

    watch(studyEngineeringVal, (newVal) => {
      if (newVal === 'yes') {
        hideAll.forEach((field) => {
          field.componentName = field.initialComponentName;
          field.isRequired = true;
        });
      } else {
        hideAll.forEach((field) => {
          field.componentName = 'hidden-field';
          field.val = '';
          field.isRequired = false;
        });
      }
    });
  }
}
